import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const MediaLightboxErrorBoundary = () =>
  import(/* webpackChunkName: "4-feat-medialightbox" */ './MediaLightboxErrorBoundary');

const LoadableMediaLightbox: ComponentType = lazyLoadOnRender({ loader: MediaLightboxErrorBoundary });
export default LoadableMediaLightbox;
